<script lang="ts">
  import BoardTile from '../board/Tile.svelte';
  import type { HighlightColors, Tile } from '../types';
  import { receive } from '~/animations/crossfade.svelte';
  import { fly } from 'svelte/transition';
  import { highlightColors } from '~/algorithms/gameLogic';
  import { definitionModal } from '~/modals/Definition.svelte';
  import { crossing } from '~/animations/crossfade.svelte';
  import { animationSpeed } from '~/animations/utils.svelte';

  type Props = {
    word: Tile[];
    highlighted?: HighlightColors;
  };
  const props: Props = $props();

  const openDefinition = (e: Event) => {
    e.stopPropagation();
    definitionModal.push(props.word.map((t) => t.letter).join(''));
  };

  const handleKeyPress = (e: KeyboardEvent) => {
    if (e.key === 'Enter') {
      openDefinition(e);
    }
  };
</script>

<div
  class="word"
  onclick={openDefinition}
  onkeypress={handleKeyPress}
  role="button"
  tabindex="-1"
>
  {#each props.word as tile, i (tile.id)}
    <div
      data-id={tile.id}
      style="grid-area: 2 / {i + 1}"
      in:receive|global={{
        key: tile.id,
        index: crossing.get(tile.id)?.index,
      }}
      out:fly|global={{
        duration: animationSpeed.ms / 2,
        delay: animationSpeed.ms / 2,
        y: 100,
      }}
    >
      <BoardTile
        {tile}
        highlighted={props.highlighted ?? highlightColors[props.word.length]}
        size="small"
      />
    </div>
  {/each}
</div>

<style lang="scss">
  .word {
    position: absolute;
    display: grid;
    align-items: center;
    justify-content: center;
    width: 100%;
    column-gap: 0.25em;
    cursor: pointer;
  }
</style>
